<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <a-form-item style="margin: 0;float: right;">
        <!-- <a-button icon="plus" type="primary" primary @click="clickAdd()">添加</a-button> -->
      </a-form-item>
      <a-form-item>
        <a-input v-model="search.name" allowClear @pressEnter="init_data" placeholder="姓名">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-tree-select
          v-model="search.groupName"
          style="width: 230px"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto'}"
          :tree-data="groupList"
          allow-clear
          placeholder="分组"
          treeNodeFilterProp ="real_name"
          show-search
          tree-default-expand-all
          :replaceFields="{children:'children', title:'real_name', key:'id',value:'name' }"
          @change="init_data"
        >
        </a-tree-select>
     </a-form-item>
     <a-form-item>
      <a-select v-model="search.status" style="width: 230px" @change="init_data" 
          placeholder="在职状态">
        <a-select-option value="">
          全部
        </a-select-option>
        <a-select-option value="1">
          在职
        </a-select-option>
        <a-select-option value="2">
          离职
        </a-select-option>
      </a-select>
     </a-form-item>

      <a-form-item style="float: right;margin: 0">
        <!--<a-button icon="sync" html-type="submit" ></a-button>-->
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData"
             style="background: #ffffff;" :loading="tableLoad" :rowKey="item=>item.id"
             bordered :pagination="false">

      <template slot="status" slot-scope="text">
        <a-tag color="green" v-if="text == 1">在职</a-tag>
        <a-tag color="red" v-if="text == 2">已离职</a-tag>
      </template>

      <template slot="handle" slot-scope="text,recode">
        <a-button size="small" @click="clickEdit(recode)">编辑</a-button>
        <a-button type="primary" size="small" primary  @click="clickAuth(recode)">菜单权限</a-button>
        <a-button type="primary" size="small" primary  @click="clickOldAuth(recode)">GB权限</a-button>
        <a-button type="primary" size="small" primary  @click="clickApp(recode)">产品权限</a-button>
        <a-button type="danger" size="small" danger v-if="recode.status == 1" @click="clickQuit(recode)">交接</a-button>
      </template>
      <template slot="footer" >
        <a-pagination
          v-model="page"
          style="text-align: right"
          show-size-changer
          :total="count"
          :page-size="page_size"
          @change="changePage"
          @showSizeChange="changePage"
        />
      </template>
    </a-table>

    <QuitDialog
          :show-dialog="quitDialogShow"
          :user-info="quitUserInfo"
          :userList="userList"
          :title="dialogQuitTitle"
          @close-dialog="closeDialog()"></QuitDialog>

    <UserAuthDialog
          :show-dialog="authShow"
          :user-info="userInfo"
          :menuList="menuList"
          :type="type"
          :title="dialogAuthTitle"
          @close-dialog="closeAuthDialog()"></UserAuthDialog>
    <UserEditDialog
          :show-dialog="userEditShow"
          :user-info="userInfo"
          :groupList="groupList"
          :title="dialogEditTitle"
          @close-dialog="closeEditDialog()"></UserEditDialog>
    <UserAppDialog
          :show-dialog="userAppShow"
          :user-info="userInfo"
          :appList="appList"
          :title="dialogAppTitle"
          @close-dialog="closeAppDialog()"></UserAppDialog>
    <UserAddDialog
          :show-dialog="userAddShow"
          :user-info="userInfo"
          :groupList="groupList"
          @close-dialog="closeAddDialog()"></UserAddDialog>
  </div>
</template>

<script>
import {GetUserPage,GetUserAll} from "@/api/v1/user_api";
import {GetMenuAll,GetOldgbMenu} from "@/api/v1/menu_api";
import {GetAppList} from "@/api/v1/app_api";
import {GetGroupTree,GetGroupInfo} from "@/api/v1/group_api";
import QuitDialog from "@/components/V1/QuitDialog";
import UserAuthDialog from "@/components/V1/UserAuthDialog";
import UserEditDialog from "@/components/V1/UserEditDialog";
import UserAddDialog from "@/components/V1/UserAddDialog";
import UserAppDialog from "@/components/V1/UserAppDialog";

export default {
  name: "User",
  components: {QuitDialog,UserAuthDialog,UserEditDialog,UserAppDialog,UserAddDialog},
  data(){
    return {
      search:{

      },
      tableData:[],
      count:100,
      page:1,
      page_size:10,
      type:0,
      tableLoad:false,
      quitDialogShow:false,
      authShow:false,
      userEditShow:false,
      userAddShow:false,
      userAppShow:false,
      quitUserInfo:{},
      userList:[],
      groupList:[],
      appList:[],
      userInfo:{},
      menuList:{},
      tmpGroupInfo:{},
      dialogAppTitle:'',
      dialogAuthTitle:'',
      dialogQuitTitle:'',
      dialogEditTitle:'',
    }
  },
  mounted() {
    this.init_data()
    this.getGroupList()

  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '姓名', dataIndex: 'name',scopedSlots: { customRender: 'name' },},
        {title: '分组', dataIndex: 'real_name',scopedSlots: { customRender: 'real_name' },},
        {title: '邮箱', dataIndex: 'email',scopedSlots: { customRender: 'email' },},
        {title: '在职状态', dataIndex: 'status',scopedSlots: { customRender: 'status' }},
        {title: '操作', dataIndex: 'handle',scopedSlots: { customRender: 'handle' }},
      ]
      return _table_columns
    }
  },
  methods: {
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetUserPage({
        name:this.search.name,
        status:this.search.status,
        group_name:this.search.groupName,
        page:this.page,
        page_size:this.page_size
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data.list
          this.count = parseInt(resp.data.count)
          this.page = parseInt(resp.data.page)
          this.page_size = parseInt(resp.data.page_size)
        }
      })
    },
    getGroupList(){
      GetGroupTree({}).then(resp => {
          if (resp.code===200){
            this.groupList = resp.data
          }
        })
    },
    changePage(page,page_size){
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    closeDialog(){
      this.quitDialogShow = false
      this.init_data()
    },
    clickQuit(record){

      this.dialogQuitTitle = '离职交接——' + record.name
      GetUserAll({}).then(resp => {
        if (resp.code===200){
            this.userList = resp.data
            this.quitUserInfo = record
            this.quitDialogShow = true
        }
      })
    },
    setIcon(treeData, dataList) {
      let that = this
      if (dataList.indexOf(String(treeData.id)) != -1) {
          treeData.slots = { icon: 'existent' }
          treeData.disableCheckbox = true
        }else{
          treeData.slots = { icon: 'non-existent' }
        }
      for (const data of treeData) {
        data.icon = ''
        if (dataList.indexOf(String(data.id)) != -1) {
          data.slots = { icon: 'existent' }
          data.disableCheckbox = true
        }else{
          data.slots = { icon: 'non-existent' }
        }
        if (data.children.length > 0) {
          that.setIcon(data.children,dataList)
        }
      }
    },
    clickAuth(record){
      this.dialogAuthTitle = '菜单权限——' + record.name
      GetGroupInfo({'name':record.group_name}).then(resp => {
        if (resp.code===200){
          this.tmpGroupInfo = resp.data
          this.dialogAuthTitle = this.dialogAuthTitle +'('+ this.tmpGroupInfo.real_name+')'
        } else {
          this.tmpGroupInfo = []
        }

        GetMenuAll({}).then(resp => {
            if (resp.code===200){
              this.menuList = resp.data
              this.setIcon(this.menuList,this.tmpGroupInfo['auth'])
              if (record.auth) {
                record.auth = record.auth.split(',').map(item => {
                  return item
                })
              } else {
                record.auth = []
              }

              record.auth2 = this.filterArray(this.menuList, record.auth);
              record.auth = this.filterArray(this.menuList, record.auth);

              record.app = []
              // record.auth2 = record.auth
              this.userInfo = record
              this.authShow = true
            }
          })
      })


    },
    filterArray(menuList, resultArr)
    {
      let hasChild = []
      hasChild = this.getHashChild(menuList,hasChild);
      resultArr = resultArr.filter((item) => {
        let flag = hasChild.indexOf(item)
        if(flag == -1) {
            return item;
        }
      });
      return resultArr
    },
    getHashChild(dataList, array) {
      dataList.forEach(e => {
        if (e.children.length > 0) {
            array.push(e.id)
            array = this.getHashChild(e.children, array)
        }
      });
      return array
    },
    clickOldAuth(record){
      this.dialogAuthTitle = '菜单权限——' + record.name
      GetGroupInfo({'name':record.group_name}).then(resp => {
        if (resp.code===200){
          this.tmpGroupInfo = resp.data
          this.dialogAuthTitle = this.dialogAuthTitle +'('+ this.tmpGroupInfo.real_name+')'
        } else {
          this.tmpGroupInfo = []
        }
        GetOldgbMenu({}).then(resp => {
          if (resp.code===200){
            this.menuList = resp.data
            this.setIcon(this.menuList, this.tmpGroupInfo['oldgb_auth'])
            let info
            info = record
            if (info.oldgb_auth) {
              info.auth = info.oldgb_auth.split(',').map(item => {
                return item
              })
            } else {
              record.auth = []
            }
            info.app = []
            info.auth2 = info.auth

            info.auth2 = this.filterArray(this.menuList, info.auth);
            info.auth = this.filterArray(this.menuList, info.auth);
            this.userInfo = info
            this.type = 'oldgb'
            this.authShow = true
          }
        })
      })

    },
    clickEdit(record){

        this.dialogEditTitle = '编辑——' + record.name
        record.is_main = record.is_main.toString()
        record.status = record.status.toString()
        record.app = []
        record.auth = []
        this.userInfo = record
        this.userEditShow = true

    },
    clickAdd(){
        this.userInfo = {}
        this.userAddShow = true
    },

    clickApp(record){

      this.dialogAppTitle = '产品权限——' + record.name
      if (record.app) {
          record.app = record.app.split(',').map(item => {
          return item
        })
      } else {
        record.app = [];
      }
      GetAppList({}).then(resp => {
        this.dataLoad = false
        if (resp.code===200){
          this.appList = resp.data
          for (let index = 0; index < this.appList.length; index++) {
            this.appList[index].label = this.appList[index].app_name
            this.appList[index].value = this.appList[index].app_id
            if (record.app.indexOf(this.appList[index].app_id) > -1) {
              this.appList[index].isHas = true
              this.appList[index].sort = 2
            } else {
              this.appList[index].isHas = false
              this.appList[index].sort = 1
            }
          }
          this.appList.sort((a, b) => {
            return b.sort - a.sort
          }, false)
          record.auth = []
          this.userInfo = record
          this.userAppShow = true
        }
      })

    },
    closeAuthDialog(){
      this.authShow = false
      this.userInfo = {}
      this.init_data()
    },
    closeAppDialog(){
      this.authShow = false
      this.userInfo = {}
      this.init_data()
    },
    closeEditDialog(){
      this.userEditShow = false
      this.userInfo = {}
      this.init_data()
    },
    closeAddDialog(){
      this.userAddShow = false
      this.userInfo = {}
      this.init_data()
    },
    closeAppDialog(){
      this.userAppShow = false
      this.userInfo = {}
      this.init_data()
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/User/User.vue